import {DbDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';

import authSchemaDefinition from './schemas/authSchemaDefinition';
import cfgSchemaDefinition from './schemas/cfgSchemaDefinition';
import dataSchemaDefinition from './schemas/dataSchemaDefinition';
import datastoreSchemaDefinition from './schemas/datastoreSchemaDefinition';


export const dbDefinition : DbDefinition = {
    schemas: {
        auth     : authSchemaDefinition,
        cfg      : cfgSchemaDefinition,
        data     : dataSchemaDefinition,
        dataStore: datastoreSchemaDefinition
    }
};

export default dbDefinition;
